<template>
    <div class="luiyan">
        <div class="luiyan-header">
            <img src="/image/ly-header.jpg" alt="">
        </div>
        <div class="luiyan-box">
            <div class="luiyan-box-title">
                <el-input class="input-box"
                          type="textarea"
                          rows="7"
                          v-model="content"
                          resize="none"
                          placeholder="输入内容"></el-input>
                <div class="submit-btn" @click="handleSubmit">提交</div>
            </div>
            <div class="line"></div>
            <div class="luiyan-box-content">
                <div class="luiyan-box-content-item" v-for="item in lists" :key="item.id">
                    <div class="luiyan-box-content">
                        <div class="l-item">
                            <div style="display: flex;align-items: flex-start;">
                                <div class="label">网友留言:</div>
                                <div class="value">{{ item.content }}</div>
                            </div>
                            <div class="date">
                                {{ moment(item.createTime).format('YYYY-MM-DD') }}
                            </div>
                        </div>
                        <div class="l-item" v-if="item.replyContent">
                            <div style="display: flex;align-items: flex-start;">
                                <div class="label">留言回复:</div>
                                <div class="value gray">{{ item.replyContent }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="tc">
                <el-pagination
                    v-if="total > pageSize"
                    background
                    layout="prev, pager, next"
                    class="tc"
                    prev-text="上一页"
                    next-text="下一页"
                    @current-change="handleCurrentChange"
                    :current-page.sync="page"
                    :total="total">
                </el-pagination>
            </div>
        </div>
        <!-- 图形验证码 -->
        <Verify ref="verify"
                :captcha-type="'blockPuzzle'"
                :img-size="{width:'400px',height:'200px'}"
                @error="handleError"
                @success="sendLuiyan" />
        <!-- <div class="liuyan-fixed-box" @click="handleLuiyan">
            <i class="el-icon-chat-line-round"></i>
            写留言
        </div> -->
        <!--   微信小程序的弹窗     -->
        <!-- <Dialog :dialog-visible.sync="dialog" title="微信小程序"  :show-submit-btn="false">
            <img style="width: 300px; height: 300px;" class="img-box" src="@/assets/imgs/update/mini.jpg">
        </Dialog>
        <img class="float-bg" src="/image/ly-bg.png" alt=""> -->
    </div>
</template>

<script setup>
import { reactive, toRefs, onMounted, ref } from 'vue';
import { messagePageGet, messageCreate } from '../api/index';
import moment from 'moment';
import { Message } from 'element-ui';
// import Dialog from '@/components/dialog.vue';
import Verify from '@/components/Verifition/Verify';
const handleCurrentChange = (val) => {
    state.page = val;
    getLists();
};

const state = reactive({
    page: 1,
    pageSize: 10,
    total: 10,
    lists: []
});
const { page, total, lists, pageSize } = toRefs(state);
const dialog = ref(false);
const content = ref('');
const verify = ref(null);
const getLists = () => {
    messagePageGet({
        pageNo: state.page,
        pageSize: state.pageSize
    }).then((res) => {
        const _data = res.data.list || [];
        state.lists = _data;
        state.total = res.data.total;
    });
};

onMounted(() => {
    getLists();
});

const handleLuiyan = () => {
    dialog.value = true;
};

const handleSubmit = () => {
    if (!content.value) {
        Message.warning('请输入内容');
        return;
    }
    verify.value.show();
};

const handleError = () => {
    Message.error('校验不通过');
    verify.value.closeBox();
};

const sendLuiyan = () => {
    messageCreate({
        anonymous: true,
        content: content.value
    }).then((res) => {
        if (res.code === 0) {
            Message.success('提交成功');
            content.value = '';
            getLists();
        }
    });
};
</script>

<style lang="scss" scoped>
.luiyan {
    width: 100%;
    background:#f7f7f7;;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    .luiyan-header {
        width: 100%;
        height:273px;
        img{
            width: 100%;
            height: 100%;
        }
    }
    .luiyan-box {
       display: flex;
       flex-direction: column;
       width: 1120px;
       position: relative;
       z-index: 2;
       .line {
            width:1120px;
            height:9px;
            background:#d2d2d2;
            margin: 77px 0 56px;
       }
       .luiyan-box-title {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            .input-box {
                padding-top: 22px;
                width: 820px;
            }
            .submit-btn {
                width:286px;
                height:62px;
                background:#ffffff;
                border:1px solid;
                border-color:#d2d2d2;
                border-radius:7px;
                cursor: pointer;
                line-height: 62px;
                text-align: center;
                margin-top: 20px;
                color:#7d7d7d;
                font-size:20px;
                margin-top: 22px;
            }
       }
       .luiyan-box-content {
            display: flex;
            flex-direction: column;
            padding-right: 19px;
            margin-right: 50px;
            .luiyan-box-content-item {
                display: flex;
                flex-direction: column;
                padding-right: 19px;
                margin-right: 50px;
                padding-bottom: 44px;
                margin-bottom: 50px;
                border-bottom:1px solid;
                border-color:rgba(112, 112, 112, 0.3);
                .l-item {
                    display: flex;
                    justify-content: space-between;
                    & + .l-item {
                        margin-top: 25px;
                    }
                }
                .label {
                    font-weight:500;
                    color:#232323;
                    font-size:20px;
                    margin-right: 7px;
                    flex-shrink: 0;
                }
                .value {
                    color:#232323;
                    font-size:18px;
                    &.gray {
                        color:#7d7d7d;
                    }
                }
                .date {
                    color:#292929;
                    font-size:20px;
                    flex-shrink: 0;
                    margin-left: 15px;
                }
            }
       }
    }
    .liuyan-fixed-box {
        position: fixed;
        top: 50%;
        right: 0;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        width:105px;
        height:105px;
        background:#675241;
        color: #fff;
        font-size:18px;
        margin-top: 70px;
        z-index: 10;
        cursor: pointer;
        i {
            font-size: 36px;
            margin-bottom: 10px;
        }    
    }
    .img-box{
        width: 300px;
        height: 300px;
    }
    .float-bg {
        width: 100%;
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 1;
    }
}
</style>